function RegexFilter(rows, id, filterValue) {

 const vaccine=RegExp(filterValue,'i');

 return rows.filter(x => vaccine.test(x.values[id[0]]));

}

export default RegexFilter;
